import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from "../../pages/login/Login";
import Registration from "../../pages/registration/Registration";
import CampaignsPage from "../../pages/campaigns/CampaignsPage";
import Characters from "../../pages/Characters";
import Home from "../../pages/home/Home";
import React from "react";
import ProtectedRoute from "./ProtectedRoute";
import Landing from "../../pages/landing/Landing";
import Lexicon from "../../pages/lexicon/Lexicon";
import AuthoringGuide from "../../pages/guide/AuthoringGuide";
import UserProfile from "../../pages/user/profile/UserProfile";
import AssetsPage from "../../pages/assets/AssetsPage";
import Marketplace from "../../pages/marketplace/Marketplace";
import CreateAssetPage from "../../pages/assets/edit/CreateAssetPage";
import EditAssetPage from "../../pages/assets/edit/EditAssetPage";
import CampaignViewPage from "../../pages/campaigns/view/CampaignViewPage";
import CreateCampaignPage from "../../pages/campaigns/create/CreateCampaignPage";
import InvitePage from "../../pages/invite/InvitePage";
import ForgotPasswordPage from "../../pages/forgot-password/ForgotPasswordPage";
import ResetPasswordPage from "../../pages/reset-password/ResetPasswordPage";
import VerifyEmailPage from "../../pages/verify-email/VerifyEmailPage";
import ResendVerificationPage from "../../pages/resend-verification/ResendVerificationPage";
import CampaignAssetEditPage from "../../pages/campaigns/assets/edit/CampaignAssetEditPage";
import { WebSocketDemo } from "../../pages/WebSocketDemo";
import { SessionPageWrapper } from "../session/SessionPageWrapper";
import AppWalkthrough from "../walkthrough/AppWalkthrough";
import FateFormulaLibraryPage from "../../pages/fateformulas/FateFormulaLibraryPage";
import PricingPage from "../../pages/pricing/PricingPage";

const RegisteredRoutes: React.FC = () => {
  return (
    <BrowserRouter>
      <AppWalkthrough />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/lexicon" element={<Lexicon />} />
        <Route path="/guide" element={<AuthoringGuide />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Registration />} />
        <Route path="/invite/:code" element={<InvitePage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route path="/resend-verification" element={<ResendVerificationPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/websocket-demo" element={<WebSocketDemo />} />
        <Route element={<ProtectedRoute />}>
          {/*<Route path="/protected/assets-tree" element={<AssetsTree/>}/>*/}
          <Route path="/protected/assets/create" element={<CreateAssetPage />} />
          <Route path="/protected/assets/:id" element={<EditAssetPage />} />
          <Route path="/protected/assets" element={<AssetsPage />} />
          <Route path="/protected/marketplace" element={<Marketplace />} />
          <Route path="/protected/characters/*" element={<Characters />} />
          <Route path="/protected/fate-formulas" element={<FateFormulaLibraryPage />} />
          <Route path="/protected/home" element={<Home />} />

          <Route path="/protected/campaigns/create" element={<CreateCampaignPage />} />
          <Route
            path="/protected/campaigns/:campaignId/assets/:assetId/edit"
            element={<CampaignAssetEditPage />}
          />
          <Route path="/protected/campaigns/:id" element={<CampaignViewPage />} />
          <Route path="/protected/campaigns" element={<CampaignsPage />} />

          <Route path="/protected/sessions/:sessionId" element={<SessionPageWrapper />} />

          <Route path="/protected/user/profile" element={<UserProfile />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};
export default RegisteredRoutes;
